import axios from 'axios';
import {
    RM_PAGE_INVESTIGATION_DATA_URL,
    RM_PAGE_SCENARIO_STATS_URL,
    RM_PEER_COMPARISON__URL,
    RM_SUBMIT_INVESTIGATION_URL,
    RM_TREND_ANALYSIS_URL,
    RM_SCORE_DECOMPOSITION
} from 'constants/api';
import { headers } from './constants';
import queryString from 'query-string';

export const rmAPI = {
    fetchRmPageStats: (params) =>
        axios
            .get(
                `${RM_PAGE_SCENARIO_STATS_URL}?${queryString.stringify(
                    params
                )}`,
                { headers }
            )
            .then((response) => response.data),
    fetchTrendData: (params) =>
        axios
            .get(`${RM_TREND_ANALYSIS_URL}?${queryString.stringify(params)}`, {
                headers
            })
            .then((response) => response.data),
    fetchPeerComparisonData: (params) =>
        axios
            .get(
                `${RM_PEER_COMPARISON__URL}?${queryString.stringify(params)}`,
                {
                    headers
                }
            )
            .then((response) => response.data),
    fetchRmInvestigationData: (params) =>
        axios
            .get(
                `${RM_PAGE_INVESTIGATION_DATA_URL}?${queryString.stringify(
                    params
                )}`,
                { headers }
            )
            .then((response) => response.data),
    submitRmInvestigation: (params) =>
        axios
            .post(
                `${RM_SUBMIT_INVESTIGATION_URL}?${queryString.stringify(
                    params.query
                )}`,
                params.postRequestPayload,
                { headers }
            )
            .then((response) => response.data),
    fetchRmScoreDecomposition: (params) =>
        axios
            .get(`${RM_SCORE_DECOMPOSITION}?${queryString.stringify(params)}`, {
                headers
            })
            .then((response) => response.data)
};
